import { CpuChipIcon } from "@heroicons/react/24/outline";
import { classNames } from "components/utils";
import React from "react";
import { normalizeArchitectures } from "utils/architecture";

interface ArchitectureBadgeProps {
  architectures?: string | Array<string | null | undefined> | null;
  className?: string;
  compact?: boolean;
  variant?: "badge" | "metadata";
}

export const ArchitectureBadge: React.FC<ArchitectureBadgeProps> = ({
  architectures,
  className,
  compact = false,
  variant = "badge",
}) => {
  const normalizedArchitectures = normalizeArchitectures(
    Array.isArray(architectures) ? architectures : [architectures],
  );

  if (normalizedArchitectures.length === 0) return null;

  const architectureLabel = normalizedArchitectures.join(" / ");
  const accessibleLabel = `Architecture: ${architectureLabel}`;
  const isMetadata = variant === "metadata";

  return (
    <span
      aria-label={accessibleLabel}
      title={accessibleLabel}
      className={classNames(
        "inline-flex w-fit shrink-0 items-center",
        isMetadata
          ? "gap-1 border-0 bg-transparent px-0 py-0 text-sm font-normal text-inherit dark:bg-transparent"
          : "rounded-md border border-zinc-700 bg-gray-100/80 font-semibold text-gray-700 dark:bg-zinc-900/80 dark:text-zinc-200",
        isMetadata
          ? ""
          : compact
            ? "gap-1 px-1.5 py-0.5 text-[10px]"
            : "gap-1.5 px-2 py-1 text-xs",
        className || "",
      )}
    >
      <CpuChipIcon
        className={isMetadata ? "h-4 w-4" : compact ? "h-3 w-3" : "h-3.5 w-3.5"}
      />
      {!isMetadata && (
        <span className="text-[0.85em] tracking-wider text-gray-500 dark:text-zinc-500">
          ARCH
        </span>
      )}
      <span>{architectureLabel}</span>
    </span>
  );
};

export default ArchitectureBadge;
